import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import request from "../../../utilities/requests";

const ChatButton = ({ eventId, attendee, refreshKey, sx }) => {
  const navigate = useNavigate();
  const [context, setContext] = React.useState(null);

  React.useEffect(() => {
    let active = true;
    const load = async () => {
      if (!eventId || !attendee?._id) return;
      const result = await request(
        `eventchat/context?eventId=${eventId}&otherUser=${attendee._id}`
      );
      if (!active) return;
      setContext(result?.success && result.available ? result : null);
    };
    load();
    return () => {
      active = false;
    };
  }, [eventId, attendee?._id, refreshKey]);

  if (!context?.threadId) return null;

  return (
    <Button
      className="tnfm-pill-btn"
      variant="contained"
      startIcon={<ChatBubbleOutlineIcon />}
      onClick={() => navigate(`/chats/${context.threadId}`)}
      sx={sx}
    >
      {context.buttonLabel}
    </Button>
  );
};

export default ChatButton;
